<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', 'All')"
        v-b-toggle.sidebar-create-direction
        variant="primary"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
      <assign-science-sector :direction="selectedDirection" />
    </template>

    <template #cell(name)="{ data }">
      {{ data.value[$i18n.locale] }}
    </template>

    <!-- Column: Id -->
    <template #cell(category_subject)="{ data }">
      {{ data.value.name[$i18n.locale] }}
    </template>

    <template #cell(is_priority)="{ data }">
      <span>
        <b-badge
          v-if="data.value === true"
          pill
          variant="success"
          class="priority-status d-inline-flex align-items-center justify-content-center"
        >
          <feather-icon
            icon="CheckIcon"
            class="priority-status-icon"
            size="20"
          />
        </b-badge>
      </span>
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-b-toggle.sidebar-create-letter
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'direction-view', params: { id: data.item.id }})"
        />
        <feather-icon
          v-if="$can('manage', 'All')"
          v-b-toggle.sidebar-create-direction
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="update(data.item)"
        />

        <feather-icon
          v-if="$can('create', 'DirectionSectorCode')"
          v-b-tooltip.hover.top="$t('Assign science sector')"
          v-b-toggle.sidebar-assign-direction-sector-code
          icon="LinkIcon"
          class="mx-1 cursor-pointer text-primary"
          size="16"
          @click="assignScienceSector(data.item)"
        />

        <feather-icon
          v-if="$can('manage', 'All')"
          :id="`invoice-row-${data.item.id}-preview-icon`"
          icon="TrashIcon"
          size="16"
          class="mx-1 cursor-pointer"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  BBadge, BButton, VBToggle, VBTooltip,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import directionModule from '@/store/direction/index'
import Create from './Create.vue'
import categorySubjectModule from '@/store/category-subject'
import directionSectorCodeModule from '@/store/direction-sector-code'
import LTable from '@/views/components/LTable.vue'
import Direction from '@/views/components/filters/service/Direction'
import AssignScienceSector from './AssignScienceSector.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },
  components: {
    BBadge,
    LTable,
    BButton,
    Create,
    AssignScienceSector,
  },
  data() {
    return {
      selectedDirection: {},
    }
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    if (this.$can('create', 'DirectionSectorCode')) {
      this.$store.dispatch('directionSectorCode/fetchCategorySubjects')
    }
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    assignScienceSector(direction) {
      this.selectedDirection = direction
      this.$store.commit('directionSectorCode/PREPARE_FOR_DIRECTION', direction.id)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    exportExcel() {
      this.$store.dispatch(`${this.MODULE_NAME}/directionDcTypeExel`).then(res => {
        const link = document.createElement('a')
        link.href = res.data.path
        link.setAttribute('download', true)
        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    },
  },
  setup() {
    const filterClass = new Direction()
    const MODULE_NAME = 'direction'
    const MODULE_CATEGORY_SUBJECT = 'category-subject'
    const MODULE_DIRECTION_SECTOR_CODE = 'directionSectorCode'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, directionModule)
    if (!store.hasModule(MODULE_CATEGORY_SUBJECT)) store.registerModule(MODULE_CATEGORY_SUBJECT, categorySubjectModule)
    if (!store.hasModule(MODULE_DIRECTION_SECTOR_CODE)) {
      store.registerModule(MODULE_DIRECTION_SECTOR_CODE, directionSectorCodeModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_CATEGORY_SUBJECT)) store.unregisterModule(MODULE_CATEGORY_SUBJECT)
      if (store.hasModule(MODULE_DIRECTION_SECTOR_CODE)) store.unregisterModule(MODULE_DIRECTION_SECTOR_CODE)
    })

    return {
      MODULE_NAME,
      ...config(),
      filterClass,
    }
  },
}
</script>

<style lang="scss" scoped>
.priority-status {
  width: 28px;
  height: 28px;
  padding: 0;
  color: #fff;
  background-color: #157347 !important;
  border: 1px solid #157347;
}

.priority-status-icon {
  color: #fff !important;
  stroke-width: 3;

  ::v-deep svg {
    color: #fff !important;
    stroke: #fff !important;
  }
}
</style>
